import {CommonService} from '../../services/common.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  templateUrl: './progress-dialog.component.html'
})
export class ProgressDialogComponent implements OnInit {
  isLoading: boolean;
  result: any;
  detailsId: number;
  resultsModel: any[] = [];
  value: number;
  message: string;
  endpoint: string;
  method: string;

  constructor(private commonService: CommonService,
              private matDialogRef: MatDialogRef<ProgressDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.result = data.result;
    this.endpoint = data.endpoint;
    this.method = data.method;
    this.detailsId = +data.detailsId;
    this.isLoading = true;
    this.message = '';
    this.value = 0;

    for (const user of data.result.users) {
      const resultModel = {
        category_id: data.result.category_id,
        status_id: data.result.status_id,
        users: [user],
      };
      this.resultsModel.push(resultModel);
    }
  }

  public async ngOnInit(): Promise<void> {
    try {
      // for (let [index, record] of this.resultsModel.entries()) {
      //   index++;
      //   this.message = `${index} / ${this.result.users.length}`;
      //   await this.sendRequest(record);
      //   this.value = (index / this.result.users.length) * 100;
      // }
      await this.sendRequest(this.result);
      setTimeout(() => {
        this.isLoading = false;
        this.matDialogRef.close(true);
      }, 2000);

    } catch (e) {
      this.matDialogRef.close();
    }
  }

  async sendRequest(result) {
    try {
      switch (this.method) {
        case 'put':
          // await this.commonService.updateObject(`questionnaire/sending/${this.detailsId}`, result);
          await this.commonService.updateObject(`${this.endpoint}`, result);
          break;
        case 'post':
          await this.commonService.insertItem(`${this.endpoint}`, result);
          break;
      }
    } catch (e) {
    }
  }

}
